import { render, staticRenderFns } from "./FileApplyDialog.vue?vue&type=template&id=504d8826&scoped=true&"
import script from "./FileApplyDialog.vue?vue&type=script&lang=ts&"
export * from "./FileApplyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FileApplyDialog.vue?vue&type=style&index=0&id=504d8826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d8826",
  null
  
)

export default component.exports